













import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { imageUrl } from '@/shared/utils/images'

@Component({
  name: 'respondeco-header-image',
})
export default class RespondecoHeaderImage extends Vue {
  @Prop({
    required: true,
  })
  public readonly image!: string | null

  public imageUrl = imageUrl
}
